module.exports = __webpack_public_path__ + "static/media/pna2.c7b25fcf.png";